import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { getDataOptionsFieldDefinition } from "@store/Framework/Common/Utilities/dataOptions";
import { blockVariantOptions } from "@store/Library/Components/Toolkit/Block/variant/config";

const blockVariantField = {
    ...getDataOptionsFieldDefinition(blockVariantOptions),
    displayName: "Variant",
} as DropDownFieldDefinition<string>;

export default blockVariantField;
